import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { ContatoTipo, CONTATOS_TIPOS, isContatoTipoQualificacao, isContatoTipoProspeccao, isContatoTipoNegociacao, isContatoTipoAcompanhamentoPedido, isContatoTipoSuporte, isContatoTipoPosVenda, isContatoTipoFeedback, isContatoTipoReclamacao, isContatoTipoOutro } from '../../contato-tipo';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

interface Config {
    isQualificacao: boolean;
    isProspeccao: boolean;
    isNegociacao: boolean;
    isAcompanhementoPedido: boolean;
    isSuporte: boolean;
    isPosVenda: boolean;
    isFeedback: boolean;
    isReclamacao: boolean;
    isOutro: boolean;
    isValid?: boolean;
}

@Component({
    selector: 'sgt-contato-tipo-select',
    templateUrl: './contato-tipo-select.component.html',
    styleUrls: ['./contato-tipo-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ContatoTipoSelectComponent), multi: true },
    ]
})
export class ContatoTipoSelectComponent implements OnInit {
    config: Config;

    /** Tipos de contas */
    tiposOptions = CONTATOS_TIPOS;

     /** Tipo do contato */
     @Input() ngModel: number;
     /** Ao alterar o tipo do contato */
     @Output() ngModelChange = new EventEmitter<number>();

    /** Tipo de contato selecionado */
    tipo: ContatoTipo;
    /** tipo de conato alterado */
    @Output() tipoChange = new EventEmitter<ContatoTipo>();

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /** Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se se o tipo de contato é obrigatório */
    @Input() required = false;

    @ViewChild('dropdownToggle') dropdownToggle: ElementRef;

    propagateChange: any = () => {};

    ngOnInit(): void {
        this.tipo = this.tiposOptions.find(tipoFilter => tipoFilter.id == this.ngModel);
        this.setConfig();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'ngModel' && !changes[propName].isFirstChange()) {
                this.tipo = this.getTipo(this.ngModel);
                this.setIsValid();
            } else if (propName === 'required') {
                this.setIsValid();
            }
        }
    }

    /** Obtem o tipo através do ID */
    private getTipo(id: number): ContatoTipo {
        if (!id || !this.tiposOptions) {
            return null;
        }
        return this.tiposOptions.find(tipoFilter => tipoFilter.id === id);
    }

    /** Ao selecionar o tipo de contato */
    onChange(tipo: ContatoTipo) {
        this.ngModel = tipo ? tipo.id : null;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);

        this.tipo = tipo;
        this.tipoChange.emit(this.tipo)

        this.setConfig();
    }

    /** Seta as configs. do select */
    private setConfig() {
        this.config = {
            isQualificacao: isContatoTipoQualificacao(this.ngModel),
            isProspeccao: isContatoTipoProspeccao(this.ngModel),
            isNegociacao: isContatoTipoNegociacao(this.ngModel),
            isAcompanhementoPedido: isContatoTipoAcompanhamentoPedido(this.ngModel),
            isSuporte: isContatoTipoSuporte(this.ngModel),
            isPosVenda: isContatoTipoPosVenda(this.ngModel),
            isFeedback: isContatoTipoFeedback(this.ngModel),
            isReclamacao: isContatoTipoReclamacao(this.ngModel),
            isOutro: isContatoTipoOutro(this.ngModel),

        }
        this.setIsValid();
    }

    private setIsValid() {
        if (!this.config) {
            return;
        }

        // Obrigatório e não selecionado o tipo de contato
        if (this.required && !this.ngModel) {
            this.config.isValid = false;
            return;
        }

        this.config.isValid = true;
    }

    get isValid(): boolean {
        return this.config.isValid;
    }

    /** Seta foco no select */
    setFocus() {
        jQuery(this.dropdownToggle?.nativeElement).trigger('focus');
    }

    writeValue(value: number) {}

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
